import { useTheme, useMediaQuery } from '@mui/material';
import TicketListPageDesktop from './TicketListPageDesktop';
import TicketListPageMobile from './TicketListPageMobile';

export default function TicketListPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return isMobile
    ? <TicketListPageMobile />
    : <TicketListPageDesktop />;
}